import { Icon } from "@/base/components/index";
import { MenuItemType } from "@/schemas/index";
import { LocalizationText } from "@/app/index";
import { Link } from "react-router-dom";

import MenuIconAccountsSvg from "../static/menu/ico-accounts.svg?react";
import MenuIconBusinessUnitsSvg from "../static/menu/ico-business-units.svg?react";
import MenuIconEmployeesSvg from "../static/menu/ico-employees.svg?react";
import MenuIconSubscriptionsSvg from "../static/menu/ico-subscriptions.svg?react";
import MenuIconHardwaresSvg from "../static/menu/ico-hardware.svg?react";
import MenuIconDeliverySvg from "../static/menu/ico-delivery.svg?react";
import MenuIconQuotesSvg from "../static/menu/ico-quotes.svg?react";
import MenuIconOrdersSvg from "../static/menu/ico-orders.svg?react";
import MenuIconInvoicesSvg from "../static/menu/ico-invoices.svg?react";
import MenuIconPaymentMethodsSvg from "../static/menu/ico-payment-methods.svg?react";
import MenuIconServiceAppoyntmentSvg from "../static/menu/ico-service-appoyntment.svg?react";
import MenuIconAddNewSvg from "../static/menu/ico-add-new.svg?react";
import MenuIconSupportCenterSvg from "../static/menu/ico-support-center.svg?react";
import MenuIconKnowledgeBaseSvg from "../static/menu/ico-knowledge-base.svg?react";
import MenuIconUniversitySvg from "../static/menu/ico-university.svg?react";
import MenuIconFaqSvg from "../static/menu/ico-faq.svg?react";
import MenuIconSupportSvg from "../static/menu/ico-support.svg?react";
import MenuIconLogOutSvg from "../static/menu/ico-log-out.svg?react";
import MenuIconUserEditSvg from "../static/menu/ico-user-edit.svg?react";
import MenuIconGiftSvg from "../static/menu/ico-gift.svg?react";

const iconMap: any = {
  ["accounts"]: <Icon component={MenuIconAccountsSvg} />,
  ["business-units"]: <Icon component={MenuIconBusinessUnitsSvg} />,
  ["employees"]: <Icon component={MenuIconEmployeesSvg} />,
  ["subscriptions"]: <Icon component={MenuIconSubscriptionsSvg} />,
  ["hardware"]: <Icon component={MenuIconHardwaresSvg} />,
  ["delivery"]: <Icon component={MenuIconDeliverySvg} />,
  ["quotes"]: <Icon component={MenuIconQuotesSvg} />,
  ["orders"]: <Icon component={MenuIconOrdersSvg} />,
  ["invoices"]: <Icon component={MenuIconInvoicesSvg} />,
  ["payment-methods"]: <Icon component={MenuIconPaymentMethodsSvg} />,
  ["service-appoyntment"]: <Icon component={MenuIconServiceAppoyntmentSvg} />,
  ["add-new"]: <Icon component={MenuIconAddNewSvg} />,
  ["support-center"]: <Icon component={MenuIconSupportCenterSvg} />,
  ["knowledge-base"]: <Icon component={MenuIconKnowledgeBaseSvg} />,
  ["university"]: <Icon component={MenuIconUniversitySvg} />,
  ["faq"]: <Icon component={MenuIconFaqSvg} />,
  ["support"]: <Icon component={MenuIconSupportSvg} />,
  ["log-out"]: <Icon component={MenuIconLogOutSvg} />,
  ["user-edit"]: <Icon component={MenuIconUserEditSvg} />,
  ["gift"]: <Icon component={MenuIconGiftSvg} />,
};

export const renderMenuItems = (menuItems: MenuItemType[]): any => {
  return (menuItems || []).map((menuItem) => ({
    key: menuItem.id,
    icon: menuItem.iconKey && iconMap[menuItem.iconKey],
    label: menuItem.href ? (
      <Link
        to={menuItem.href}
        target={menuItem.target || "_self"}
        rel="noopener noreferrer"
      >
        {<LocalizationText value={`header.menu.item.text.${menuItem.id}`} />}
      </Link>
    ) : (
      <LocalizationText value={`header.menu.item.text.${menuItem.id}`} />
    ),
    children: menuItem.children && renderMenuItems(menuItem.children),
  }));
};
